import { render, staticRenderFns } from "./SimOrderDetail.vue?vue&type=template&id=e317d748&"
import script from "./SimOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SimOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SimOrderDetail.vue?vue&type=style&index=0&id=e317d748&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports